import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { Link } from 'reusable';

import { Badge, Menu } from 'antd';
import { UserOutlined, WarningTwoTone } from '@ant-design/icons';

import { EmptyHeader } from 'components';
import {
  CREATING,
  FINISHED,
  HISTORICAL_SCENARIO,
  logout,
  PLAYING,
  REAL_TIME_SCENARIO,
  selectors,
} from 'state';
import { failedExecutions } from '../../state/app/selectors';
import { CountdownTimer } from '../../components/Charts/CountdownTimer';
import { isV5MarketsExperience } from './MarketsTabV5/route';

const MyHeader: React.FC = () => {
  const dispatch = useDispatch();
  const {
    status,
    scenario_type,
    allow_individual_benchmark,
    show_auctions,
    show_analysis_studio_tab,
    next_historical_period_task_time,
    which_markets,
  } = useSelector(selectors.activeSession);
  const assets = useSelector(selectors.underlyingAssets);
  const player = useSelector(selectors.player);
  const selectedPerson = useSelector(selectors.selectedPerson);
  const username = useSelector(selectors.username);
  const failedExecutions = useSelector(selectors.failedExecutions);
  const canSeeDevplan = useSelector(selectors.canSeeDevplan);
  const { url } = useRouteMatch();

  const isFinished = status === FINISHED;
  const isV5Markets = isV5MarketsExperience(which_markets);

  const isRealTime = scenario_type === REAL_TIME_SCENARIO;

  const sessionHasNoEquities = Object.values(assets).every(
    asset => asset.resourcetype !== 'Equity',
  );
  const hasOptions = useSelector(selectors.sessionHasOptions);
  let errorBadge: number | JSX.Element = 0;
  if (failedExecutions !== undefined && failedExecutions.length !== 0) {
    errorBadge = <WarningTwoTone twoToneColor="#FFBF00" />;
  }

  const showEquitiesResearch = isRealTime && !sessionHasNoEquities;

  const showAuctions =
    scenario_type === HISTORICAL_SCENARIO &&
    status !== CREATING &&
    show_auctions;
  const showNews =
    scenario_type === HISTORICAL_SCENARIO && !isFinished && !isV5Markets;

  return (
    <EmptyHeader defaultKey="graph" home={`${url}`}>
      {/*{!isFinished && (*/}
      {/*  <Menu.Item key="risk-profile">*/}
      {/*    <Link to={`${url}/risk-profile`}>Risk Profile</Link>*/}
      {/*  </Menu.Item>*/}
      {/*)}*/}
      {(!isFinished || isV5Markets) && (
        <Menu.Item key="markets">
          <Link to={`${url}/markets`}>Markets</Link>
        </Menu.Item>
      )}
      {showEquitiesResearch && (
        <Menu.Item key="equities-research">
          <Link to={`${url}/equities-research`}>Equities Research</Link>
        </Menu.Item>
      )}
      <Menu.Item key="blotter">
        <Link to={`${url}/blotter`}>Blotter</Link>
      </Menu.Item>
      <Menu.Item key="open-orders">
        <Link to={`${url}/open-orders`}>Open Orders</Link>
        <Badge count={errorBadge} offset={[15, -10]}></Badge>
      </Menu.Item>
      {hasOptions && (
        <Menu.Item key="options">
          <Link to={`${url}/options`}>Options</Link>
          {/*<Badge count={errorBadge} offset={[15, -10]}></Badge>*/}
        </Menu.Item>
      )}
      {showAuctions && (
        <Menu.Item key="central_bank">
          <Link to={`${url}/central_bank`}>Central Bank</Link>
          <Badge count={errorBadge} offset={[15, -10]}></Badge>
        </Menu.Item>
      )}
      {showNews && (
        <Menu.Item key="news2">
          <Link to={`${url}/news2`}>News</Link>
        </Menu.Item>
      )}
      {/*{scenario_type === HISTORICAL_SCENARIO && !isFinished && (*/}
      {/*  <Menu.Item key="news">*/}
      {/*    <Link to={`${url}/news`}>News</Link>*/}
      {/*  </Menu.Item>*/}
      {/*)}*/}
      <Menu.Item key="portfolio">
        <Link to={`${url}/portfolio`}>Portfolio</Link>
      </Menu.Item>
      {/*{allow_individual_benchmark && (*/}
      {/*  <Menu.Item key="benchmarks">*/}
      {/*    <Link to={`${url}/benchmarks`}>Benchmarks</Link>*/}
      {/*  </Menu.Item>*/}
      {/*)}*/}
      <Menu.Item key="metrics">
        <Link to={`${url}/metrics`}>Metrics</Link>
      </Menu.Item>
      {/*{!isFinished && (*/}
      {/*  <Menu.Item key="capital-usage">*/}
      {/*    <Link to={`${url}/capital-usage`}>Capital Usage</Link>*/}
      {/*  </Menu.Item>*/}
      {/*)}*/}
      {scenario_type === HISTORICAL_SCENARIO && (
        <Menu.Item key="macro-background">
          <Link to={`${url}/macro-background`}>Macro Background</Link>
        </Menu.Item>
      )}
      {show_analysis_studio_tab && (
        <Menu.Item key="analysis-studio">
          <Link to={`${url}/analysis-studio`}>Analysis Studio</Link>
        </Menu.Item>
      )}
      {/*<Menu.Item key="insights">*/}
      {/*  <Link to={`${url}/insights`}>Portfolio Insights</Link>*/}
      {/*</Menu.Item>*/}
      <Menu.Item style={{ marginLeft: 'auto' }}>
        {next_historical_period_task_time !== null ? (
          <CountdownTimer
            runAtIso={next_historical_period_task_time}
            status={status}
          />
        ) : (
          <span></span>
        )}
      </Menu.Item>
      {username ? <Menu.Item>{username}</Menu.Item> : ''}
      <Menu.Item key="exit-session">
        <Link to={canSeeDevplan ? '/dashboard/development-plan' : '/dashboard'}>
          Exit session
        </Link>
      </Menu.Item>
      <Menu.SubMenu
        title={
          <>
            <UserOutlined />
            {selectedPerson?.name || player?.name}
          </>
        }
      >
        {/*<Menu.Item>*/}
        {/*  <Link to={`${url}/settings`}>Settings</Link>*/}
        {/*</Menu.Item>*/}
        <Menu.Item onClick={() => dispatch(logout({}))}>Logout</Menu.Item>
      </Menu.SubMenu>
    </EmptyHeader>
  );
};

export default MyHeader;
